module.exports = __webpack_public_path__ + "img/instagram.14ddb7b1.svg";